import ObjektService from '@/services/ObjektService'
import Vue from 'vue'

const state = {
  item: {},
  loading: false,
  saving: false
}

const getters = {
  loading: state => !!state.loading,
  saving: state => !!state.saving,
  item: state => (payload) => {
    let index = payload.Objektid + '/' + payload.Bilagsid

    return state.item.hasOwnProperty(index) ? state.item[index] : null
  }
}

const actions = {
  get: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit('get', payload)

      let index = payload.Objektid + '/' + payload.Bilagsid

      if (state.item !== {} && state.item.hasOwnProperty(index)) {
        commit('get_cached_success')
        resolve(state.item[index])
      } else {
        ObjektService.getObjektBilag(payload.Objektid, payload.Bilagsid)
          .then((response) => {
            let data = {
              index: index,
              data: response.data
            }

            commit('get_success', data)
            resolve(response.data)
          })
          .catch((error) => {
            commit('get_failure', index)
            reject(error)
          })
      }
    })
  }
}

const mutations = {
  /** Item methods follow */
  get: (state, payload) => {
    state.loading = true
  },
  get_success: (state, data) => {
    Vue.set(state.item, data.index, data.data)

    state.loading = false
  },
  get_cached_success: (state) => {
    console.log('Get cached success')
    state.loading = false
  },
  get_failure: (state, index) => {
    if (state.item.hasOwnProperty(index)) {
      Vue.delete(state.item, index)
    }

    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/objektbilag.js